/* Keeps the hidden "Wunschmaß-Anfertigung" add-on in step with the bands that carry a
   Wunschmaß measurement: one add-on unit per made-to-measure band. Runs after every cart
   change the theme makes (quantity edits, removals, adds) and on page load, and re-renders
   the cart when it had to correct the add-on. */
(function () {
  var cfg = window.ZelalWunschmass;
  if (!cfg || !cfg.addonVariant || !window.routes) return;
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var nativeFetch = window.fetch;
  var running = null;
  var again = false;

  // The add-on's own requests go through nativeFetch, so they never re-trigger the hook.
  // They ask for the same sections the theme's cart element renders, and paint them the
  // way cart.js does, so the page shows the corrected add-on without a reload.
  function sectionsFor(items) {
    if (items && items.getSectionsToRender) return items.getSectionsToRender();
    return [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
  }

  function paint(state, sections, items) {
    if (typeof state.item_count === 'number') {
      var empty = state.item_count === 0;
      if (items) items.classList.toggle('is-empty', empty);
      var footer = document.getElementById('main-cart-footer');
      if (footer) footer.classList.toggle('is-empty', empty);
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.toggle('is-empty', empty);
    }
    sections.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = state.sections && state.sections[s.section];
      if (!host || !html) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (src) (host.querySelector(s.selector) || host).innerHTML = src.innerHTML;
    });
  }

  function correct(isRetry) {
    return nativeFetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var need = 0, addon = null;
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (p._wunschmass === '1') need += item.quantity;
          if (p._wunschmass_addon === '1') addon = item;
        });
        var have = addon ? addon.quantity : 0;
        if (need === have) return false;
        var items = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
        var sections = sectionsFor(items);
        var body = addon
          ? { id: addon.key, quantity: need }
          : { items: [{ id: cfg.addonVariant, quantity: need, properties: { _wunschmass_addon: '1' } }] };
        body.sections = sections.map(function (s) { return s.section; }).join(',');
        body.sections_url = window.location.pathname;
        return nativeFetch(addon ? window.routes.cart_change_url : window.routes.cart_add_url, { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            // Shopify answers errors (422: stale line key, stock) as {status, message, description}
            // or {errors}; the cart is then still out of step, so re-read it and try once more.
            if (!state || state.status || state.errors) {
              if (!isRetry) return correct(true);
              console.warn('Wunschmaß add-on sync failed', state && (state.description || state.message || state.errors));
              return false;
            }
            paint(state, sections, items);
            return true;
          });
      })
      .catch(function (e) {
        if (!isRetry) return correct(true);
        console.error(e);
        return false;
      });
  }

  // Serialised: a cart change that lands while a correction is running queues one more pass.
  function sync() {
    if (running) { again = true; return running; }
    running = correct().then(function (changed) {
      running = null;
      if (again) { again = false; return sync().then(function (c2) { return changed || c2; }); }
      return changed;
    });
    return running;
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (/\/cart\/(change|update|add)/.test(url)) {
      result.then(function () {
        sync();
      }, function () {});
    }
    return result;
  };

  // Carts can arrive stale (back/forward cache, another tab): check once per page view too,
  // and again when the page is restored from the back/forward cache (no scripts re-run then).
  sync();
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) sync();
  });
})();
